module.exports = __webpack_public_path__ + "static/media/a4_03.695e70f1.jpg";